import { LtlPipelineViewModel } from "../ViewModel/LtlPipelineViewModel";

function getLtlPipelinesWithLaunchBatches(
  ltlPipelines: Array<LtlPipelineViewModel>,
  spdrLaunchBatches: Record<string, number | null>,
  pdsrLaunchBatches: Record<string, number | null>
) {
  const ltlPipelinesCopy = [...ltlPipelines];

  Object.entries(spdrLaunchBatches).forEach(([key, value]) => {
    const launchBatch = value;
    const spdrId = parseInt(key, 10);
    const ltlPipeline = ltlPipelinesCopy?.find(
      (item: LtlPipelineViewModel) => item.SpdrId === spdrId
    );
    if (!ltlPipeline) {
      return;
    }

    ltlPipeline.LaunchBatch = launchBatch;
  });

  Object.entries(pdsrLaunchBatches).forEach(([key, value]) => {
    const launchBatch = value;
    const pdsrId = parseInt(key, 10);
    const ltlPipeline = ltlPipelinesCopy?.find(
      (item: LtlPipelineViewModel) => item.PdsrId === pdsrId
    );
    if (!ltlPipeline) {
      return;
    }

    ltlPipeline.LaunchBatch = launchBatch;
  });

  return ltlPipelinesCopy;
}

export default getLtlPipelinesWithLaunchBatches;
